import { render, staticRenderFns } from "./zone-card.vue?vue&type=template&id=07886535&scoped=true"
import script from "./zone-card.vue?vue&type=script&lang=js"
export * from "./zone-card.vue?vue&type=script&lang=js"
import style0 from "./zone-card.vue?vue&type=style&index=0&id=07886535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07886535",
  null
  
)

export default component.exports